import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Accounts, Storage } from 'actions';
import {
  getHoldTotalMarketValue,
  hasNegativeWeight,
} from '../../../utils/helpers';
import CashAnalyze from '../../../components/CashAnalyze';

class Cash extends Component {
  /*
    Creates a "Cash holding" in order to account for the amount of cash in the analysis
    The security_detail parameter is required for the "convertToTickersAndWeights" function in the utils/helpers.js file
  */
  getCash = (account) => {
    const cash = {
      account: account.id,
      account_id: account.id,
      currency: account.currency,
      market_value: account.cash,
      name: 'Cash',
      security: 'CASH:MKT',
      ticker: 'CASH:MKT',
      security_detail: {
        exchange_symbol: 'CASH:MKT',
        ticker: 'CASH:MKT',
        long_name: 'Cash',
        unadjusted_closing_price: {
          CAD: 1,
          USD: 1,
        },
      },
      unadjusted_closing_price: {},
    };
    const holdingsCash = account.holdings.concat(cash);
    return holdingsCash;
  };

  analyze = (holdings, region) => {
    const { account, dispatch, history } = this.props;
    const gicHoldings = holdings.filter((holding) => holding.gic_ticker);
    Storage.removeItem('pwpa-has-exclude-holding');

    return dispatch(
      Accounts.analyze(holdings, history, account, gicHoldings, region)
    );
  };

  render() {
    const { account, dispatch, user_region, pwpaExchangeRate } = this.props;
    const hasNegativeWeights = hasNegativeWeight(account.holdings);
    const isNegativePort =
      getHoldTotalMarketValue(account, pwpaExchangeRate, user_region) < 0;

    return (
      <CashAnalyze
        hasNegativeWeights={hasNegativeWeights}
        isNegativePort={isNegativePort}
        analyze={this.analyze}
        dispatch={dispatch}
        holdings={this.getCash(account)}
      />
    );
  }
}

Cash.propTypes = {
  account: PropTypes.object,
  dispatch: PropTypes.func,
  history: PropTypes.object,
  user_region: PropTypes.string,
  pwpaExchangeRate: PropTypes.number,
};

Cash.defaultProps = {
  account: {},
  dispatch: () => {},
  history: {},
  user_region: 'CA',
  pwpaExchangeRate: 0,
};

export default connect((state) => ({
  user_region: state.Storage.user_region,
  pwpaExchangeRate: state.Storage['pwpa-exchange-rate'],
}))(Cash);
